export default function CTABonus() {
  return (
    <section className="bg-white py-16 sm:py-24 px-4 sm:px-6">
      <div className="max-w-4xl mx-auto">
        <div className="bg-gray-50 rounded-3xl border-t-4 border-[#EA9D00] p-6 sm:p-10 md:p-12 shadow-lg">
          <div className="text-center mb-6 sm:mb-8">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
              <span className="text-4xl sm:text-5xl">⚠️</span>
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#2A2A2A] mb-4 sm:mb-6">
              BÔNUS EXCLUSIVO
            </h2>
          </div>

          <div className="space-y-4 sm:space-y-6 text-[#2A2A2A]">
            <p className="text-base sm:text-lg md:text-xl leading-relaxed">
              Um bônus especial será liberado somente para quem estiver{' '}
              <strong className="text-[#EA9D00]">AO VIVO</strong> na live e também no{' '}
              <strong className="text-[#EA9D00]">grupo exclusivo do WhatsApp</strong>.
            </p>

            <div className="space-y-3 sm:space-y-4 pl-4 sm:pl-8">
              <div className="flex items-start gap-2 sm:gap-3">
                <span className="text-xl sm:text-2xl flex-shrink-0">👉</span>
                <p className="text-sm sm:text-base md:text-lg leading-relaxed">
                  Na última edição, quem aproveitou não se arrependeu.
                </p>
              </div>
              <div className="flex items-start gap-2 sm:gap-3">
                <span className="text-xl sm:text-2xl flex-shrink-0">👉</span>
                <p className="text-sm sm:text-base md:text-lg leading-relaxed">
                  Agora, essa é a sua chance de sair na frente e fazer parte de um movimento que está crescendo rápido.
                </p>
              </div>
            </div>

            <div className="bg-[#EA9D00]/10 rounded-2xl p-4 sm:p-6 mt-6 sm:mt-8 border-l-4 border-[#EA9D00]">
              <p className="text-sm sm:text-base md:text-lg font-semibold text-[#2A2A2A]">
                ⏳ Vagas limitadas! Garanta a sua agora mesmo.
              </p>
            </div>

            <div className="text-center pt-4 sm:pt-6">
              <a
                href="https://chat.whatsapp.com/HlxOc0MOTd992aTE1YYBIN?mode=gi_t"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-[#EA9D00] text-[#2A2A2A] font-bold text-sm sm:text-base md:text-lg px-6 sm:px-10 md:px-12 py-3 sm:py-4 rounded-full hover:bg-[#d89000] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                GARANTIR MINHA VAGA GRATUITA
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
